import '../common/types/pwa-register.d.ts';
import 'clipsal-cortex-utils/src/build/polyfills';
import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

interface ContextProps {
  isUpdateRequired: boolean;
  reloadPage: () => void;
}

const ServiceWorkerContext = createContext({} as ContextProps);

// eslint-disable-next-line react-refresh/only-export-components
export const useServiceWorker = () => useContext(ServiceWorkerContext);

interface Props {
  readonly children: ReactNode;
}

export default function ServiceWorkerProvider({ children }: Props) {
  const {
    needRefresh: [isUpdateRequired],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      // eslint-disable-next-line prefer-template
      console.log('SW Registered: ' + r);
    },
    onRegisterError(error) {
      console.log('SW registration error', error);
    },
  });

  const reloadPage = async () => {
    await updateServiceWorker(true);
  };

  const value = useMemo(() => ({ isUpdateRequired, reloadPage }), [isUpdateRequired, reloadPage]);

  return <ServiceWorkerContext.Provider value={value}>{children}</ServiceWorkerContext.Provider>;
}
